import { Endpoints } from "../constants/endpoint";

export const markParagraphWord = async (id, mark) => {
  try {
    const res = await fetch(`${Endpoints.paragraphWords}${id}/mark`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({ mark }),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (err) {
    return err.message;
  }
};
